import { customFields } from 'ducks/entities/schema'

export const customFieldsNormalizationSchema = {
  customFields: {
    nodes: [customFields],
  },
}
